import { routePaths } from '../../routePaths';
import { translate } from '../../utils';
import { RouteType } from '../../types';
import { BackofficePermission } from '../../generated/graphql';
import { DiscountIcon } from '../../ui-kit';
import DiscountListView from './DiscountListView';
import DiscountCreateView from './DiscountCreateView';
import DiscountUpdateView from './DiscountUpdateView';

const DiscountRoute: RouteType = {
    exact: true,
    path: routePaths.discounts,
    icon: DiscountIcon,
    title: translate('Discounts'),
    component: DiscountListView,
    permissions: {
        backoffice: [BackofficePermission.HasAccess]
    },
    childrenRoutes: [
        {
            title: translate('Create Discount'),
            exact: true,
            path: routePaths.discountsCreate,
            component: DiscountCreateView,
        },
        {
            title: translate('Update Discount'),
            exact: true,
            path: routePaths.discountsUpdate,
            component: DiscountUpdateView,
        },
    ]
};

export default DiscountRoute;
